<!-- /app/frontend/pages/Layout.svelte -->
<script lang="ts">
  import Nav from '$lib/components/Nav.svelte';
  import { usePage } from '@inertiajs/svelte';
  import { onMount } from 'svelte';
  import { ModeWatcher } from "mode-watcher";
  import Toast, { toast } from "$lib/components/ui/toast";
  
  // 1. 接收 Svelte 5 标准的 children 属性
  let { children } = $props();

  // 2. 将 $effect 内的追踪逻辑精细化
  const page = usePage();
  $effect(() => {
    // 显式声明对 page 变化的追踪
    const currentPage = page; 
    const flash = currentPage?.props?.flash;

    if (flash?.notice) {
      toast.success(flash.notice);
      flash.notice = null; // 清理防重复
    }

    if (flash?.alert) {
      toast.error(flash.alert);
      flash.alert = null;
    }
    
    if (flash?.info) {
      toast.info(flash.info);
      flash.info = null;
    }
  });

  onMount(() => {
    
  });

  let year = new Date().getFullYear();
</script>

<ModeWatcher />
<Toast />

<div class="min-h-screen flex flex-col bg-neutral-100 dark:bg-neutral-900">
  <!-- <Nav /> -->
  <main class="flex-1">
    <!-- 3. 使用 Svelte 5 的代码片段渲染子组件，替代旧的 <slot /> -->
    {@render children?.()}
  </main>
  <!-- <footer class="text-center text-sm text-gray-500 dark:text-gray-400 py-4">
    &copy; {year} fentime.cn
  </footer> -->
</div>